// import React, { useState, useEffect, useMemo } from "react";
// import { Typography, Grid } from "@mui/material";
// import CustomTable from "components/TableExplanded/Table";
// import CustomPagination from "components/TableExplanded/Pagination";
// import useProductData from "pages/Pawn/List/SettingPrice/data/data";
// import useColumns from "pages/Pawn/List/SettingPrice/columns/mainColumns";
// import useColumnsTwo from "pages/Pawn/List/SettingPrice/columns/subColumns";
// import Modal from "components/Modal/Pawn/Create/ModalSettingPrice";
// import ViewModal from "components/Modal/Pawn/View/ViewSettingPrice";
// import SearchBar from "components/TableExplanded/SearchBar";
// import AddCircleIcon from "@mui/icons-material/AddCircle";

// import { GradientButton } from "components/GradientButton";
// import dayjs from "dayjs";
// import api from "_api";

// const SettingPrice = ({ className }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [isViewModalOpen, setViewModalOpen] = useState(false);
//   const [selectedProduct, setProduct] = useState(null);
//   const [viewProduct, setViewProduct] = useState(null);
//   const [filteredRows, setFilteredRows] = useState([]);
//   const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
//   const [fetchData, setFetchData] = useState();
//   const [searchQuery, setSearchQuery] = useState(""); // Store the search query
//   const [dataLength, setDataLength] = useState(0);

//   useEffect(() => {
//     console.log("viewProduct", viewProduct);
//   }, [viewProduct]);
//   const fetchProductData = async () => {
//     try {
//       const { data, isStatus } = await api.product.getSellOrdersToSetPrice();
//       console.log("data", data);
//       if (isStatus) setFetchData(data);
//     } catch (error) {
//       console.error("Error fetching product data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchProductData();
//   }, []);

//   // console.log("data display new data", fetchData);

//   const handleModalOpen = () => {
//     setModalOpen(!isModalOpen);
//     if (selectedProduct && isModalOpen) setProduct(null);
//   };

//   const handleViewOpen = () => {
//     setViewModalOpen(!isViewModalOpen);
//     if (viewProduct && isViewModalOpen) setViewProduct(null);
//   };

//   const data = useProductData(fetchData);
//   const columns = useColumns(
//     setViewProduct,
//     setProduct,
//     handleViewOpen,
//     handleModalOpen
//   );
//   const columnsInside = useColumnsTwo();
//   const visibleColumns = columns.filter((col) => col.showInFilter);

//   const filteredData = useMemo(() => {
//     if (!searchQuery) return data; // If no search query, return all data

//     return data.filter((row) => {
//       return visibleColumns.some((column) => {
//         const cellValue = row[column.accessor]?.toString()?.toLowerCase();
//         return cellValue && cellValue.includes(searchQuery.toLowerCase());
//       });
//     });
//   }, [data, searchQuery, visibleColumns]);

//   const handleSearchChange = (event) => {
//     // Check if event.target and event.target.value are defined
//     if (
//       event &&
//       event.target &&
//       event.target.value !== undefined &&
//       event.target.value !== null
//     ) {
//       setSearchTerm(event.target.value.toLowerCase());
//       setSearchQuery(event.target.value);
//     } else {
//       console.error("Event target or value is undefined");
//     }
//     setPage(0);
//   };

//   const handleClear = () => {
//     setSearchTerm("");
//     setPage(0);
//   };

//   const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleRowsPerPageChange = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   return (
//     <div className={className}>
//       <Grid container spacing={2} style={{ marginBottom: "16px" }}>
//         <Grid
//           item
//           xs={12}
//           sm={12}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <Typography component="div" style={{ fontSize: "32px" }}>
//             ตั้งราค่าคาขาย
//           </Typography>
//           <Grid display={"flex"} style={{ gap: "8px" }}>
//             <GradientButton
//               onClick={handleModalOpen}
//               sx={{
//                 px: 3,
//                 display: "flex",
//                 alignItems: "center",
//                 height: "48px",
//               }}
//             >
//               <Typography style={{ marginRight: "8px" }}>ตั้งราคา</Typography>
//               <AddCircleIcon fontSize="medium" />
//             </GradientButton>
//           </Grid>
//         </Grid>
//       </Grid>

//       <SearchBar
//         columns={columns}
//         searchTerm={setSearchTerm}
//         visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
//         handleSearchChange={handleSearchChange}
//         handleClear={handleClear}
//         fetchData={fetchData}
//         QRCode={false}
//       />

//       <CustomTable
//         columns={columns}
//         columnsInside={columnsInside}
//         searchTerm={searchTerm}
//         data={filteredData}
//         page={page}
//         rowsPerPage={rowsPerPage}
//         setDataLength={setDataLength}
//       />
//       <CustomPagination
//         count={searchTerm ? dataLength : filteredData.length}
//         page={page}
//         rowsPerPage={rowsPerPage}
//         onPageChange={handlePageChange}
//         onRowsPerPageChange={handleRowsPerPageChange}
//       />

//       <Modal
//         open={isModalOpen}
//         onClose={handleModalOpen}
//         selectedProduct={selectedProduct}
//         fetchProductData={fetchProductData}
//       />

//       <ViewModal
//         open={isViewModalOpen}
//         onClose={handleViewOpen}
//         selectedProduct={viewProduct}
//       />
//     </div>
//   );
// };

// export default SettingPrice;

import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid } from "@mui/material";
import CustomTable from "components/TableExplanded/Table";
import CustomPagination from "components/TableExplanded/Pagination";
import useProductData from "pages/Pawn/List/SettingPrice/data/data";
import useColumns from "pages/Pawn/List/SettingPrice/columns/mainColumns";
import useColumnsTwo from "pages/Pawn/List/SettingPrice/columns/subColumns";
import Modal from "components/Modal/Pawn/Create/ModalSettingPrice";
import ViewModal from "components/Modal/Pawn/View/ViewSettingPrice";
import SearchBar from "components/TableExplanded/SearchBar";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import { GradientButton } from "components/GradientButton";
import dayjs from "dayjs";
import api from "_api";

const SettingPrice = ({ className }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectedProduct, setProduct] = useState(null);
  const [viewProduct, setViewProduct] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [fetchData, setFetchData] = useState();
  const [searchQuery, setSearchQuery] = useState(""); // Store the search query
  const [dataLength, setDataLength] = useState(0);

  useEffect(() => {
    console.log("viewProduct", viewProduct);
  }, [viewProduct]);
  const fetchProductData = async ({ search = "", page = 1, limit = 10 }) => {
    try {
      const { data, isStatus, total } =
        await api.product.getSellOrdersToSetPriceV2({ search, page, limit });
      if (isStatus) {
        setFetchData(data);
        setDataLength(total); // Set the total data length for pagination
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchProductData({
      search: searchQuery,
      page: page + 1,
      limit: rowsPerPage,
    });
  }, [searchQuery, page, rowsPerPage]);

  // console.log("data display new data", fetchData);

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };

  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen
  );
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  // const filteredData = useMemo(() => {
  //   if (!searchQuery) return data; // If no search query, return all data

  //   return data.filter((row) => {
  //     return visibleColumns.some((column) => {
  //       const cellValue = row[column.accessor]?.toString()?.toLowerCase();
  //       return cellValue && cellValue.includes(searchQuery.toLowerCase());
  //     });
  //   });
  // }, [data, searchQuery, visibleColumns]);

  const handleSearchChange = (event) => {
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      const query = event.target.value.toLowerCase();
      setSearchTerm(query);
      setSearchQuery(query);
    } else {
      console.error("Event target or value is undefined");
    }
    setPage(0);
  };

  const handleClear = () => {
    setSearchTerm("");
    setSelectedDateRange([null, null]);
    setFilteredRows(data);
    setPage(0);
    fetchProductData({ search: "", page: 1, limit: rowsPerPage });
  };

  const handlePageChange = (event, newPage) => {
    if (searchTerm != null) {
      setSearchQuery(searchTerm.order_code);
    }
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            ตั้งราค่าคาขาย
          </Typography>
          <Grid display={"flex"} style={{ gap: "8px" }}>
            <GradientButton
              onClick={handleModalOpen}
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "48px",
              }}
            >
              <Typography style={{ marginRight: "8px" }}>ตั้งราคา</Typography>
              <AddCircleIcon fontSize="medium" />
            </GradientButton>
          </Grid>
        </Grid>
      </Grid>

      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        fetchData={fetchData}
        handleSearchClick={(filters) => {
          console.log("filter>>>>", filters);

          fetchProductData({
            search: filters.search || "",
            page: 1,
            limit: rowsPerPage,
          });
        }}
        QRCode={false}
      />

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        setDataLength={setDataLength}
      />
      <CustomPagination
        count={dataLength}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        fetchProductData={() =>
          fetchProductData({
            search: searchQuery,
            page: page + 1,
            limit: rowsPerPage,
          })
        }
      />

      <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        selectedProduct={viewProduct}
      />
    </div>
  );
};

export default SettingPrice;
